import React from "react"
import { Routes, Route, Navigate } from "react-router-dom"
import {
  Minimal as MinimalLayout,
  AdminMain as AdminMainLayout,
} from "./layouts"
import * as COMMONS from "common/common"

import {
  AdminLogin as AdminLoginView,
  AdminShipments as AdminShipmentsView,
  AdminReservationList as AdminReservationListView,
  AdminPurchases as AdminPurchasesView,
  AdminProducts as AdminProductsView,
  AdminProductsSort as AdminProductsSortView,
  AdminProductStock as AdminProductStockView,
  AdminCustomers as AdminCustomersView,
  AdminNotificationSettings as AdminNotificationSettingsView,
  AdminPickupSettings as AdminPickupSettingsView,
  AdminShipmentSettings as AdminShipmentSettingsView,
  AdminPointSettings as AdminPointSettingsView,
  AdminRichMenuSettings as AdminRichMenuSettingsView,
  AdminTaxSettings as AdminTaxSettingsView,
  PermissionError as PermissionErrorView,
  NotFound as NotFoundView,
} from "./views"

const RouteManagement = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={<Navigate replace to={COMMONS.ADMIN_LOGIN_ROUTE} />}
      />
      <Route
        path={COMMONS.ADMIN_LOGIN_ROUTE}
        element={
          <MinimalLayout>
            <AdminLoginView />
          </MinimalLayout>
        }
      />
      <Route
        path={COMMONS.ADMIN_SHIPMENTS_ROUTE}
        element={
          <AdminMainLayout>
            <AdminShipmentsView />
          </AdminMainLayout>
        }
      />
      <Route
        path={COMMONS.ADMIN_RESERVATION_LIST_ROUTE}
        element={
          <AdminMainLayout>
            <AdminReservationListView />
          </AdminMainLayout>
        }
      />
      <Route
        path={COMMONS.ADMIN_PURCHASES_ROUTE}
        element={
          <AdminMainLayout>
            <AdminPurchasesView />
          </AdminMainLayout>
        }
      />
      <Route
        path={COMMONS.ADMIN_PRODUCTS_ROUTE}
        element={
          <AdminMainLayout>
            <AdminProductsView />
          </AdminMainLayout>
        }
      />
      <Route
        path={COMMONS.ADMIN_PRODUCTS_SORT_ROUTE}
        element={
          <AdminMainLayout>
            <AdminProductsSortView />
          </AdminMainLayout>
        }
      />
      <Route
        path={COMMONS.ADMIN_PRODUCTS_STOCK_ROUTE}
        element={
          <AdminMainLayout>
            <AdminProductStockView />
          </AdminMainLayout>
        }
      />
      <Route
        path={COMMONS.ADMIN_PRODUCTS_STOCK_ROUTE}
        element={
          <AdminMainLayout>
            <AdminProductStockView />
          </AdminMainLayout>
        }
      />
      <Route
        path={COMMONS.ADMIN_CUSTOMERS_ROUTE}
        element={
          <AdminMainLayout>
            <AdminCustomersView />
          </AdminMainLayout>
        }
      />
      <Route
        path={COMMONS.ADMIN_NOTIFICATION_SETTINGS_ROUTE}
        element={
          <AdminMainLayout>
            <AdminNotificationSettingsView />
          </AdminMainLayout>
        }
      />
      <Route
        path={COMMONS.ADMIN_PICKUP_SETTINGS_ROUTE}
        element={
          <AdminMainLayout>
            <AdminPickupSettingsView />
          </AdminMainLayout>
        }
      />
      <Route
        path={COMMONS.ADMIN_POINT_SETTINGS_ROUTE}
        element={
          <AdminMainLayout>
            <AdminPointSettingsView />
          </AdminMainLayout>
        }
      />
      <Route
        path={COMMONS.ADMIN_SHIPMENT_SETTINGS_ROUTE}
        element={
          <AdminMainLayout>
            <AdminShipmentSettingsView />
          </AdminMainLayout>
        }
      />
      <Route
        path={COMMONS.ADMIN_RICHMENU_SETTINGS_ROUTE}
        element={
          <AdminMainLayout>
            <AdminRichMenuSettingsView />
          </AdminMainLayout>
        }
      />
      <Route
        path={COMMONS.ADMIN_TAX_SETTINGS_ROUTE}
        element={
          <AdminMainLayout>
            <AdminTaxSettingsView />
          </AdminMainLayout>
        }
      />
      <Route
        path={COMMONS.PERMISSION_ERROR_ROUTE}
        element={
          <MinimalLayout>
            <PermissionErrorView />
          </MinimalLayout>
        }
      />
      <Route
        path={COMMONS.NOT_FOUND_ROUTE}
        element={
          <MinimalLayout>
            <NotFoundView />
          </MinimalLayout>
        }
      />
      <Route
        path="*"
        element={<Navigate replace to={COMMONS.NOT_FOUND_ROUTE} />}
      />
    </Routes>
  )
}

export default RouteManagement
